import { styled } from "@mui/system";
import { TableRow } from "@mui/material";
import { TextareaAutosize } from "@mui/base/TextareaAutosize";
import { FaCaretDown, FaMagnifyingGlass } from "react-icons/fa6";
import { FiAlertCircle } from "react-icons/fi"
import { FaRegFilePdf } from "react-icons/fa";

import { colors } from "../../../styles/colors";
import fontWeight from "../../../styles/mui/fontWeight";

export const FaMagnifyingGlassIcon = styled(FaMagnifyingGlass as React.ComponentType)(() => ({
  color:colors.portalColor[1],
  fontSize:"1rem",
}));

export const FaCaretDownIcon = styled(FaCaretDown as React.ComponentType)(() => ({
  margin: "0 0 0.2rem 0.2rem",
  fontSize:"0.7rem",
}));

export const HomeHeaderBox = () => ({
  width: "100%",
  backgroundColor: colors.white[1],
  padding: "0.8rem 0.5rem",
  marginTop: "0.5rem",
});

export const AuthTrackerButton = () => ({
  margin: 0,
});

export const PatientListButton = () => ({
  margin: 0,
  borderRadius: "0 0.3125rem  0.3125rem 0 ",
});

export const AddUserInputStyle = {
  width: "22rem",
  border: "2px solid #ccc",
  borderRadius: "5px",
  "& .MuiInput-input.MuiSelect-select": {
    height: "1.6rem",
  },
  "& .MuiInput-input": {
    padding: "0.7rem 0 0.1rem 0.8rem",
    fontSize: "0.95rem",
  },
  "&:hover:not(.Mui-disabled, .Mui-error):before": {
    borderBottom: 0,
  },
  "&::before": {
    borderBottom: 0,
  },
  "&::after": {
    borderBottom: 0,
  },
};

export const SearchTextfield = {
  width: "12rem",
  "& input::placeholder": {
    color: colors.portalColor[1],
    fontWeight: fontWeight[2],
    fontSize: "0.9rem",
    opacity: 0.9,
  },
  "& .MuiOutlinedInput-root": {
    "&.Mui-focused fieldset": {
      boxShadow: `2px 2px 10px ${colors.dropShadow[3]}`,
    },
    "&.Mui-error fieldset": {
      boxShadow: `2px 2px 10px ${colors.dropShadow[3]}`,
    },
  },
};

export const AuthDetailsBox = (isActive: boolean) => ({
  width: "100%",
  backgroundColor: isActive ? colors.portalColor[4] : colors.portalColor[11],
  padding: "0.3rem 0.3rem 0.3rem 2.5rem",
  marginTop: "0.6rem",
});

export const AuthDetailsGrid = () => ({
  backgroundColor: colors.white[1],
  padding: "1rem",
  display: "flex",
});

export const displayButton = ()=>({
  display:"grid",
  gridTemplateColumns:"repeat(5, auto)",
})

export const TableCellStyle = {
  borderBottom: "unset",
  padding: "1rem 0",
};

export const HeadCell30 = {
  width: "0.7rem",
};

export const HeadCell10 = {
  width: "0.4rem",
};

export const HeadCell20 = {
  width: "0.8rem",
};

export const HeadCell50 = {
  width: "6.5rem",
};

export const HeadCell70 = {
  width: "7.5rem",
};

export const HeadCell90 = {
  width: "10.5rem",
};

export const PatientListHeaderTitleGrid = () => ({
  paddingTop: "1.3rem",
});

export const SearchIconButton = () => ({
  backgroundColor: colors.portalColor[5],
  margin: "0",
  minWidth: 0,
  border: `1px solid ${colors.portalColor[6]}`,
});

export const ClearButton = () => ({
  backgroundColor: colors.portalColor[7],
  color: colors.black[17],
  marginLeft: "1rem",
});

export const NoResultFoundText = () => ({
  padding: "2rem 0 0.5rem 0",
});

export const ReferralName = () => ({
  paddingBottom: "0.4rem",
  textDecoration: "underline",
});

export const ReAuthButton = (status: string) => ({
  margin: 0,
  fontSize: "0.7rem",
  fontWeight: fontWeight[3],
  backgroundColor: status !== "Active" ? colors.portalColor[8] : colors.primary.main
});

export const NtuButton = () => ({
  backgroundColor: colors.portalColor[4],
  color: colors.portalColor[2],
  fontSize: "0.7rem",
  fontWeight: fontWeight[3],
  margin:"0rem",
  padding: "1rem 0"
});
export const NoMnCButton = () => ({
  backgroundColor: colors.portalColor[4],
  color: colors.portalColor[2],
  fontSize: "0.7rem",
  fontWeight: fontWeight[3],
  margin:"0rem"
});


export const SocButton = ()=>({
  color: colors.portalColor[2],
  border: `2px solid ${colors.portalColor[31]}`,
  fontSize: "0.7rem",
  fontWeight: fontWeight[3],
  margin:"0rem"
})

export const DownloadButton = () => ({
  backgroundColor: colors.portalColor[8],
  fontSize: "0.7rem",
  fontWeight: fontWeight[3],
  margin:"0rem",
  width:"100%",
});

export const ViewAuthHistoryButton = () => ({
  border: "1px solid rgba(0, 0, 0, .125)",
  color: colors.fonts[18],
  padding: "0.4rem 0.75rem",
  backgroundColor: colors.portalColor[9],
  textTransform: "capitalize",
  fontSize: "1rem",
  fontWeight: fontWeight[2],
  width: "100%",
  WebkitJustifyContent: "flex-start",
  justifyContent: "flex-start",
  margin: 0,
  "&:hover": {
    textDecoration: "underline",
    border: `3px solid ${colors.portalColor[15]}`,
    backgroundColor: colors.portalColor[9],
  },
  "&:active": {
    backgroundColor: colors.portalColor[9],
  },
});

export const ViewAuthHistoryGrid = () => ({
  border: "1px solid rgba(0, 0, 0, .125)",
  marginTop: "1.1rem",
  borderRadius: "0.2125rem",
});

export const TableContainerStyle = () => ({
  padding: "1rem 2rem",
});

export const HeaderTableCell = () => ({
  borderBottom: `2px solid ${colors.portalColor[10]}`,
  borderTop: `1px solid ${colors.portalColor[10]}`,
});

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
}));

export const TotalDisciplineGrid = () => ({
  background: colors.portalColor[12],
  textAlign: "center",
});

export const DisciplineGrid = () => ({
  textAlign: "center",
});

export const ModalContainer = () => ({
  position: "relative",
  width: "32%",
  backgroundColor: "background.paper",
  padding: "1.2rem",
  border: `0.15rem solid ${colors.grey[1]}`,
  borderRadius: "0.25rem",
});

export const TextAreaStyle = {
  width: "100%",
  fontWeight: fontWeight[2],
  fontSize: "0.8rem",
  "&::placeholder": {
    fontSize: "0.8rem",
  },
};

export const StyledTextarea = styled(TextareaAutosize)({
  width: "100%",
  fontWeight: fontWeight[1],
  color: colors.portalColor[2],
  fontSize: "0.98rem",
  fontFamily: "DM Sans",
  padding: "0.3rem 0 0.2rem 0.8rem",
  "&::placeholder": {
    fontSize: "0.98rem",
  },
});

export const CountTextfield = {
  paddingTop: "0.8rem",
  width: "12rem",
  "& input::placeholder": {
    color: colors.portalColor[1],
    fontWeight: fontWeight[2],
    fontSize: "0.9rem",
    opacity: 0.9,
  },
  "& .MuiOutlinedInput-root": {
    height: "1.9rem",
    "&.Mui-focused fieldset": {
      boxShadow: `1px 1px 10px ${colors.dropShadow[3]}`,
    },
    "&.Mui-error fieldset": {
      boxShadow: `1px 1px 10px ${colors.dropShadow[3]}`,
    },
  },
};

export const AutoComplete = {
  width: "23rem",
  border: "0.0625rem solid #ccc",
  borderRadius: "0.3rem",
  "& .MuiInput-underline:after": {
    borderBottom: 0,
  },
  "& .MuiInput-underline:before": {
    borderBottom: 0,
  },
  "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
    borderBottom: 0,
  },
  "& .MuiAutocomplete-inputRoot": {
    paddingLeft: "1rem",
    height: "2.5rem",
    "& .MuiAutocomplete-input": {
      color: colors.portalColor[2],
      fontSize: "0.95rem",
      fontWeight: 400,
    },
  },
};

export const NoOptionTextStyle = () => ({
  "& .MuiAutocomplete-noOptions": {
    border: "0.0625rem solid #ccc",
    borderRadius: "0.3rem",
    boxShadow: "none",
    padding: "1rem",
  },
});

export const CheckboxGrid = () => ({
  padding: "0 0 1.8rem 0.6rem",
});

export const DataGrid = () => ({
  height: "5.7rem",
});

export const VisitGrid = () => ({
  height: "5.4rem",
});

export const NtuReasonAutocomplete = {
  paddingTop: "0.2rem",
  width: "100%",
  borderRadius: "0.3rem",
  "& .MuiOutlinedInput-root": {
    paddingRight: 0,
    "& input": {
      marginLeft: "0.7rem",
      borderRadius: "0.0625rem",
      padding: "0",
      fontSize: "0.8rem",
    },
    "&.Mui-focused fieldset": {
      borderColor: colors.fonts[8],
      border: `2px solid ${colors.fonts[8]}`,
    },
    "& .MuiInputLabel-root": {
      display: "none",
    },
    "&.Mui-error fieldset": {
      borderColor: "0.08rem solid #ccc",
    },
  },
  "& .MuiAutocomplete-inputRoot": {
    paddingLeft: 0,
    height: "2.5rem",
    paddingRight: 0,
    "& .MuiAutocomplete-input": {
      color: colors.portalColor[2],
      fontSize: "0.95rem",
      fontWeight: fontWeight[2],
    },
  },
};

export const CheckboxStyle = () => ({
  padding: 0,
});

export const PatientName = () => ({
  fontSize: "1.4rem",
});

export const DownIcon = {
  margin: "0 0 0.2rem 0.2rem",
};

export const AuthContainer = {
  display: "flex",
  flexDirection: "column",
  maxWidth: "100%",
  minWidth: "90%",
  maxHeight: "75vh",
  overflowY: "auto",
};

export const DownloadButtonBox = () => ({
  position: "relative",
});

export const TableCellRow = (index: number, isTotal?: boolean) => ({
    fontWeight: isTotal ? fontWeight[6] : fontWeight[3],
    backgroundColor: index % 2 === 0 ? colors.backgroundColor[1] : colors.white[1],
})

export const CloseButton = {
  borderRadius: "1.3rem",
  backgroundColor: colors.primary.main,
  color: colors.white[1],
  minWidth: "5rem",
  margin: "0 0.5rem 0 0 ",
};

export const FiAlertCircleIcon = styled(FiAlertCircle as React.ComponentType)(() => ({
  color: colors.red[100],
  fontSize: "1.1rem",
  cursor: "pointer",
}));

export const UnavailibilityContainer = () => ({
  position: "relative",
  width: "43%",
  backgroundColor: "background.paper",
  padding: "1rem 0rem 1rem 1.5rem",
  border: "none",
  overflowY: "auto",
  borderRadius: "0.4rem",
});

export const UnavailabilityMessage = () => ({
  paddingLeft: "0.5rem",
  display: "flex",
  alignItems: "center",
});

export const DocumentNameUnderline = {
  textDecoration: "1px underline",
};

export const DocumentTableContainerStyle = () => ({
  padding: "0rem 2rem 1rem 0rem",
  height: "auto",
  maxHeight: 300,
  overflowY: "auto",
  boxShadow: "none",
  mb: 2,
});

export const DocumentContainer = () => ({
  position: "relative",
  width: "43%",
  maxHeight: "unset",
  backgroundColor: "background.paper",
  padding: "1rem 1.5rem",
  border: "none",
  overflow: "visible",
  borderRadius: "0.4rem",
});

export const DocumentTableHead = () => ({
  position: "sticky",
  top: 0,
  zIndex: 2,             
});

export const CloseButtonGrid = () => ({
  position: "sticky",
  bottom: 0,
  left: 0,
  background: "background.paper",
  zIndex: 3,
  pb: 1,
});

export const FaRegFilePdfIcon = styled(FaRegFilePdf as React.ComponentType)(() => ({
  height: "1.5rem",
  width: "1.5rem",
}));

export const DocumentModalTableRow = () => ({ 
  '& td, & th': { borderBottom: 'none' } 
});

export const NOMNC_Modal = () => ({
  width: "70%",
  backgroundColor: colors.backgroundColor[1],
  borderRadius: 1,
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  boxShadow: 24,
  p: 2,
  maxHeight: "90vh",
  overflowY: "auto" 
});

export const SOC_Modal = () => ({
  width: "30%",
  backgroundColor: colors.backgroundColor[2],
  borderRadius: 1,
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  boxShadow: 24,
  p: 2,
  maxHeight: "90vh",
  padding: "2rem"
});

export const FilePdfIcon = styled(FaRegFilePdf as React.ComponentType)(() => ({
  height: "1.2rem",
  width: "1.2rem",
  color: colors.fonts[18]
}));

export const AuthNotificationsPaper = () => ({
  position: "absolute",
  top: "100%",
  right: "0rem",
  left: "auto",
  zIndex: 10,
  maxHeight: "20rem",
  overflowY: "auto",
  border: `1px solid ${colors.portalColor[18]}`,
  borderRadius: "0.25rem",
  minWidth: "15rem",
  maxWidth: "35rem",
});

export const AuthNotificationsButton = () => ({
  width: "100%",
  minHeight: "2.75rem",
  height: "auto",
  padding: "0.5rem 0.75rem",
  margin: "0.25rem 0",
  backgroundColor: "transparent",
  fontWeight: 300,
  fontSize: "0.8rem",
  color: colors.portalColor[2],
  textTransform: "none",
  textAlign: "left",
  justifyContent: "space-between",
  gap: "0.75rem",
});

export const AuthNotificationListCell = () => ({
  padding: "0.5rem 0.5rem",
});